export {default} from './SectionHeader';
